<script>
    export let active = false;
    export let toggleMethod = () => {};
</script>

<style>
    .container {
        display: none;
        background: var(--color-light);
    }

    .container.active {
        display: block;
    }

    h3 {
        margin: 0;
    }

    ul li {
        margin-top: 0.4em;
    }

    ul + p {
        margin-bottom: 0;
    }

    button {
        display: flex;
        position: absolute;
        top: var(--margin-small);
        right: var(--margin-small);
        height: 32px;
        border-radius: 16px;
        place-items: center;
        place-content: center;
        color: var(--color-light);
        background-color: var(--color-interaction);
        border: 1px solid var(--color-interaction);
        cursor: pointer;
    }

    button svg.close-icon {
        fill: var(--color-light);
    }

    @media (max-width: 480px) {
        .container {
            font-size: 12px;
        }
    }
</style>

<div class={`container ${active ? 'active' : ''}`}>
    <h3>Metode</h3>
    <p>Denne metoden er ikke nøyaktig nok til å forutsi gjennomsnittspriser, men kan gi en forståelse for hvordan oljepris og bensinpris henger sammen.</p>
    <p>Dette har vi gjort:</p>
    <ul>
        <li>Vi har tatt utgangspunkt i de historiske bensinprisene fra SSB og trukket fra skatter og avgifter funnet hos Skatteetaten.</li>
        <li>For hver måned har vi så funnet forholdet mellom denne prisen og oljeprisen i kroner.</li>
        <li>Gjennomsnittet av dette tallet er så brukt som forholdstallet. Dette avgjør hvilken pumpepris som fremkommer i kalkulatoren.</li>
    </ul>
    <p>Faktorer som ikke er spesifisert i beregningen er konkurranse, raffineri- og fraktkapasitet.</p>
    <button on:click={toggleMethod}>
        <svg
            class="close-icon"
            width="18"
            height="18"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.981 4.261L10.49 8.753l4.986 4.986L14.215 15l-4.986-4.986L4.26 14.98 3 13.721l4.968-4.968L3.495 4.28l1.261-1.261L9.229 7.49 13.72 3l1.261 1.261z"
            />
        </svg>
    </button>
</div>
